import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(
    private userService: UserService,
    private ngxPermissionsService: NgxPermissionsService
  ) {}

  setEncryptedCache(data: any) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), 'SPC').toString();
    const cache = {
      data: encrypted,
      timestamp: Date.now()
    };
    localStorage.setItem('p', JSON.stringify(cache));
  }

  getEncryptedCache() {
    const item = localStorage.getItem('p');
    if (!item) return null;

    const parsed = JSON.parse(item);
    // 15 minutes
    if (Date.now() - parsed.timestamp > 15 * 60 * 1000) {
      localStorage.removeItem('p');
      return this.userService.getPermissionCodeList().subscribe(res => {
        if (res.data?.length) {
          this.setEncryptedCache(res.data);
          this.ngxPermissionsService.loadPermissions(res.data);
        }
      });
    }

    const bytes = CryptoJS.AES.decrypt(parsed.data, 'SPC');
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}
